__turbopack_context__.v({
  "isLabelMax": "label-module-scss-module__rK45SW__isLabelMax",
  "label": "label-module-scss-module__rK45SW__label",
  "labelContainer": "label-module-scss-module__rK45SW__labelContainer",
  "labelMax": "label-module-scss-module__rK45SW__labelMax",
  "labelMin": "label-module-scss-module__rK45SW__labelMin",
  "labelValue": "label-module-scss-module__rK45SW__labelValue",
});
